import React, { useState } from "react";
import FeedCard from "~/components/feed/card/FeedCard";

import { ICompany } from "~/types/types";
import ProfilePicture from "@govlaunch/profile-picture";
import { FormattedMessage } from "react-intl";
import IntlRelativeTime from "~/src/shared/components/IntlRelativeTime";
import Link from "next/link";

interface IVendorJoinedGroupFeedItem {
  vendor: Pick<ICompany, "_id" | "name" | "slug" | "logo">;
  createdAt: any;
}

const VendorJoinedGroupFeedItem = ({ vendor, createdAt }: IVendorJoinedGroupFeedItem) => {
  const index = Math.round(Math.random() * 1);
  // eslint-disable-next-line react/hook-use-state
  const [background] = useState(["/static/feed/blue-background.png", "/static/feed/purple-background.png"][index]);

  return (
    <FeedCard
      css={{
        backgroundImage: `url(${background})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
      }}
    >
      <div
        css={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <Link href="/vendors/[vendorSlug]" as={`/vendors/${vendor.slug}`} passHref={true} legacyBehavior={true}>
          <a
            css={{
              display: "flex",
            }}
          >
            <ProfilePicture size={45} image={vendor.logo} name={vendor.name} />
          </a>
        </Link>

        <div
          css={{
            marginLeft: 12,
          }}
        >
          <p
            css={{
              color: "#fff",
              fontSize: 15,
            }}
          >
            <Link href="/vendors/[vendorSlug]" as={`/vendors/${vendor.slug}`} passHref={true} legacyBehavior={true}>
              <a
                css={{
                  color: "#fff",
                  fontWeight: 600,
                  ":hover": {
                    textDecoration: "underline !important",
                  },
                }}
              >
                {vendor.name}
              </a>
            </Link>

            <span>
              {" "}
              <FormattedMessage defaultMessage="joined this group" id="bHJLnv" />{" "}
            </span>
          </p>

          <p
            css={{
              color: "#fff",
              margin: "8px 0 0",
              fontSize: 14,
            }}
          >
            <IntlRelativeTime value={createdAt} />
          </p>
        </div>
      </div>
    </FeedCard>
  );
};

export default VendorJoinedGroupFeedItem;
